import { useContext, useMemo } from 'react'
import { Dimensions, Position } from 'types'
import { ArtboardContext } from '../../board/context'

const DEFAULT_CROP_OFFSET = { height: 0, width: 0, x: 0, y: 0 }

const useTextPosition = (dimensions: Dimensions, defaultPosition?: Position): Position | undefined => {
    const { crop, ...board } = useContext(ArtboardContext)
    const cropOffsetPosition: Position = useMemo(() => {
        if (!crop || defaultPosition) {
            return DEFAULT_CROP_OFFSET
        }

        return {
            height: crop.height - board.height,
            width: crop.width - board.width,
            x: crop.x,
            y: crop.y,
        }
    }, [crop, defaultPosition, frames])

    const position = useMemo(() => {
        if (defaultPosition) {
            return defaultPosition
        }

        if (!dimensions.width || !dimensions.height) {
            return
        }

        const boardWidth = board.width + cropOffsetPosition.width
        const boardHeight = board.height + cropOffsetPosition.height

        const aspectRatio = dimensions.width / dimensions.height
        const textWidth = crop ? Math.min(crop.width, dimensions.width) : dimensions.width
        const textHeight = Math.round(textWidth / aspectRatio)
        const textX = Math.round(boardWidth / 2) + cropOffsetPosition.x
        const textY = Math.round(boardHeight * 0.95 - textHeight / 2) + cropOffsetPosition.y

        return {
            height: textHeight,
            rotation: 0,
            width: textWidth,
            x: textX,
            y: textY,
        }
    }, [cropOffsetPosition, dimensions.height, dimensions.width])

    return position
}

export default useTextPosition
